import Swiper from 'swiper';
import { breakpoints } from '../conf';

export default () => {
  const options = {
    loop: true,
    initialSlide: 1,
    autoHeight: true,
    updateOnImagesReady: true,
    preloadImages: true,
    pagination: {
      el: '[data-triple-col-swiper-pagination]',
      clickable: true
    },
    centeredSlides: true,
    breakpoints: {
      [breakpoints.lg]: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  };

  const swipers = document.querySelectorAll('[data-triple-col-swiper]');

  swipers.forEach(el => {
    const slideCount = el.dataset.tripleColSwiperSlides;

    if (slideCount && parseInt(slideCount) && parseInt(slideCount) < 3) {
      options.loop = false;
      options.watchOverflow = true;
      options.centerInsufficientSlides = true;
      options.centeredSlides = false;

      el.classList.add('triple-col-swiper--show-all');
    }

    var mySwiper = new Swiper(el, options);
  });
};